export default "__VITE_ASSET__21a86aaf__"